import { ISettings } from "@/utils/types";
import Hamburger from "hamburger-react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { Button } from "./button";

export function Header({ data }: { data: ISettings }) {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const router = useRouter();
  // Next's <Link> throws on an undefined href, which would break rendering of
  // every page, so nav items saved without a link in the CMS are skipped.
  const topNav = data.headerTopNav?.filter((item) => item.link) ?? [];
  const mainNav = data.headerNav?.filter((item) => item.link) ?? [];
  return (
    <header className="bg-white w-full sticky top-0 z-50 ">
      {topNav.length > 0 && (
        <div className="w-full bg-black flex justify-center items-center pt-2">
          <div className=" w-fit flex gap-2">
            {topNav.map((item, i) => (
              <Link
                key={i}
                className={`px-2 py-1 ${
                  router.asPath === item.link
                    ? `bg-white text-black`
                    : `text-white`
                }`}
                href={item.link}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
      <div className="max-w-page m-auto p-4 flex justify-between items-center">
        <Link href={"/"}>
          <Image src="/logo.svg" alt="Logo" width={125} height={50} />
        </Link>
        <div className="md:hidden">
          <Hamburger
            color="black"
            toggled={isMenuVisible}
            toggle={setMenuVisible}
          />
        </div>
        {/* mobile menu */}
        <nav
          className={`md:hidden fixed top-[80px] left-0 right-0 bottom-0 flex flex-col transition-all bg-white z-10 ${
            isMenuVisible ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="px-4 py-16 flex flex-col items-center gap-4 justify-center">
            {mainNav.map((item, i) => (
              <Link key={i} className="text-2xl text-black" href={item.link}>
                {item.label}
              </Link>
            ))}
            {data.headerButtonLink && data.headerButtonLabel ? (
              <Button
                link={data.headerButtonLink}
                label={data.headerButtonLabel}
              />
            ) : null}
          </div>
        </nav>
        <nav className="hidden md:flex justify-between items-center gap-8 text-darkGrey">
          {mainNav.map((item, i) => (
            <Link key={i} href={item.link}>
              {item.label}
            </Link>
          ))}
          {data.headerButtonLink && data.headerButtonLabel ? (
            <Button
              link={data.headerButtonLink}
              label={data.headerButtonLabel}
            />
          ) : null}
        </nav>
      </div>
      {data.headerCtaTitle &&
        data.headerCtaLink &&
        data.headerCtaLabel &&
        data.headerCtaBgColor &&
        data.headerCtaAccentColor &&
        router.asPath.includes("/doe-dagen") === false && (
          <div
            style={{
              backgroundColor: data.headerCtaBgColor.value,
              color: data.headerCtaAccentColor.value,
            }}
            className="w-full"
          >
            <div className="max-w-page m-auto py-2 px-4 w-full flex gap-4 justify-between items-center">
              <p className="hidden md:block">{data.headerCtaTitle}</p>
              <p className="md:hidden">{data.headerCtaTitleMobile}</p>
              <a className="font-display" href={data.headerCtaLink}>
                {data.headerCtaLabel}
              </a>
            </div>
          </div>
        )}
    </header>
  );
}
